import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";
import { parseConnectionConfiguration } from "../source-settings/SourceSettingsConfiguration";
import type { ZendeskConfiguration } from "./ZendeskSourceSettings.types";

/**
 * What must be set before a Zendesk connection can import tickets, translated, or "" when nothing
 * is missing. Filter mode needs at least one status; View mode needs a view; both need a done status.
 */
export const getZendeskSourceSettingsValidationMessage = (
  editingConnection: ConnectionEditState,
  t: (key: string) => string,
): string => {
  if (!editingConnection.isAuthorised) {
    return "";
  }

  const configuration = parseConnectionConfiguration<ZendeskConfiguration>(
    editingConnection.configuration,
  );
  const tKey = (key: string): string =>
    t(`board.connections.dialog.sourceSettings.zendesk.${key}`);

  if (configuration.mode === "View") {
    if (!configuration.view) {
      return tKey("viewRequired");
    }
  } else if ((configuration.statuses ?? []).length === 0) {
    return tKey("statusesRequired");
  }

  return configuration.doneStatus ? "" : tKey("doneStatusRequired");
};
